import { useWeb3React } from '@web3-react/core';
import { useEffect, useState } from 'react';

import { useEagerConnect, useInactiveListener } from '@/hooks/useWeb3Connect';
import { injected, walletconnect, walletlink } from '@/utils/connectors';

export enum ConnectorNames {
  MetaMask = 'MetaMask',
  WalletLink = 'WalletLink',
  WalletConnect = 'WalletConnect',
}

export const connectorsByName = {
  [ConnectorNames.MetaMask]: injected,
  [ConnectorNames.WalletLink]: walletlink,
  [ConnectorNames.WalletConnect]: walletconnect,
};

const useConnectErc20Wallet = () => {
  const context = useWeb3React();
  const { connector, activate } = context;
  const [activatingConnector, setActivatingConnector] = useState();

  useEffect(() => {
    if (activatingConnector && activatingConnector === connector) {
      setActivatingConnector(undefined);
    }
  }, [activatingConnector, connector]);

  const triedEager = useEagerConnect();
  useInactiveListener(!triedEager || !!activatingConnector);

  const connectErc20Wallet = async (name: ConnectorNames) => {
    const currentConnector: any = connectorsByName[name];
    setActivatingConnector(currentConnector);
    await activate(connectorsByName[name]);
  };

  return { connectErc20Wallet };
};

export default useConnectErc20Wallet;
